module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/bg-4-6a5964920b82b4aa7b0a0e5e7988a500.png";